import styled from "styled-components";
import { colors, font, radius, shadow } from "../../styles/theme/tokens";

// Блок «Шукаємо вчителя» на сторінці «Пробні уроки»

export const Wrap = styled.section`
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-bottom: 24px;
  font-family: ${font.text};
  color: ${colors.ink};
`;

export const Head = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  h3 {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0;
    font-size: 20px;
    font-weight: 800;
  }
`;

export const Count = styled.span`
  padding: 2px 10px;
  border-radius: ${radius.pill};
  font-size: 14px;
  color: ${colors.brandDeep};
  background: ${colors.brandSoft};
`;

export const Cards = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 14px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 18px;
  border-radius: ${radius.lg};
  background: ${colors.surface};
  box-shadow: ${shadow.card};
  border-left: 4px solid ${({ $tone }) => ($tone === "done" ? colors.success : $tone === "off" ? colors.line : colors.amber)};
  opacity: ${({ $tone }) => ($tone === "off" ? 0.7 : 1)};
`;

export const CardTitle = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;

  b {
    font-size: 17px;
    font-weight: 800;
  }

  small {
    color: ${colors.muted};
    white-space: nowrap;
  }
`;

export const Facts = styled.dl`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 4px 10px;
  margin: 0;
  font-size: 14px;

  dt {
    color: ${colors.muted};
  }

  dd {
    margin: 0;
    overflow-wrap: anywhere;
  }
`;

export const Responses = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px 12px;
  border-radius: ${radius.md};
  font-size: 14px;
  background: ${colors.bg};
`;

export const Muted = styled.span`
  font-size: 13px;
  color: ${colors.muted};
`;

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
`;

export const Button = styled.button`
  padding: 9px 14px;
  border: none;
  border-radius: ${radius.md};
  font-family: ${font.text};
  font-size: 14px;
  font-weight: 800;
  cursor: pointer;
  color: ${({ $kind }) => ($kind === "primary" ? "#FFFFFF" : $kind === "danger" ? colors.danger : colors.brandDeep)};
  background: ${({ $kind }) => ($kind === "primary" ? colors.brand : $kind === "danger" ? colors.dangerSoft : colors.brandSoft)};

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 14px;
  border: 1px solid ${colors.line};
  border-radius: ${radius.md};
`;

export const Error = styled.small`
  font-size: 13px;
  font-weight: 600;
  color: ${colors.danger};
`;

export const TeacherList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 360px;
  overflow-y: auto;
  padding: 14px;
  border-radius: ${radius.lg};
  background: ${colors.surface};
  box-shadow: ${shadow.card};
`;

export const TeacherRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 6px 0;
  border-bottom: 1px solid ${colors.line};
  font-size: 14px;

  &:last-child {
    border-bottom: none;
  }
`;
